







































































import { Vue, Component, Prop } from 'vue-property-decorator';
import WebDialog from '@/components/ui/Dialog.vue';
import tutorial1 from '@/assets/tutorial/tuition-tutorial-01.png';
import tutorial2 from '@/assets/tutorial/tuition-tutorial-02.png';
import tutorial3 from '@/assets/tutorial/tuition-tutorial-03.png';
import tutorial4 from '@/assets/tutorial/tuition-tutorial-04.png';
import tutorial5 from '@/assets/tutorial/tuition-tutorial-05.png';
@Component({
  components: {
    WebDialog,
  },
})
export default class TuitionTutorial extends Vue {
  @Prop() isShowTutorial!: boolean;
  title = this.$t(
    '腾讯金融科技推出的留学汇款产品，通过小程序以人民币支付境外院<br/>校的学费，全线上操作，快捷省心。'
  );
  items = [
    {
      itemTitle: this.$t('搜索“跨境汇款 微汇款”小程序，</br>进入“留学缴费”首页'),
      itemContent: this.$t('微信搜索或扫描二维码进入后，点击“留学汇款”'),
      itemImg: tutorial1,
    },
    {
      itemTitle: this.$t('选择缴费学校与收款账户'),
      itemContent: this.$t('可选择收款账户或自行添加学校账户'),
      itemImg: tutorial2,
    },
    {
      itemTitle: this.$t('确认总支付金额'),
      itemContent: this.$t('填写缴费金额并确认总支付金额'),
      itemImg: tutorial3,
    },
    {
      itemTitle: this.$t('补充个人信息及缴费凭证'),
      itemContent: this.$t('请提前准备学生个人信息、录取通知书及缴费通知单'),
      itemImg: tutorial4,
    },
    {
      itemTitle: this.$t('支付并等待到账'),
      itemContent: this.$t('支付完成后，预计1-3个工作日到账境外院校账户'),
      itemImg: tutorial5,
    },
  ];
  // 当前展示的攻略页面
  activeClass = 0;
  chooseTutorial(item, index) {
    this.activeClass = index;
  }
  // 关闭弹窗
  handleCloseDialog() {
    this.$emit('closeDialog');
  }
}
